<div class="editor-container" [ngClass]="formGroup ? '' : 'alert alert-danger'">
  <form [formGroup]="formGroup">
    <quill-editor
      [style.minWidth]="minWidth"
      [style.maxWidth]="maxWidth"
      [style.minHeight]="minHeight"
      #editor
      [formControlName]="formControlName"
      format="html"
      [placeholder]="'Type here...'"
      [modules]="quillModules"
      (onContentChanged)="handleContentChange($event)"
    >
      <div
        quill-editor-toolbar
        id="customToolbarId"
        [style.maxWidth]="maxWidth"
        [ngClass]="editor.disabled ? 'ql-disabled' : ''"
      >
        <span class="ql-formats">
          <select class="ql-size">
            <option selected="selected">Default</option>
            <option value="10px">10</option>
            <option value="11px">11</option>
            <option value="12px">12</option>
            <option value="14px">14</option>
            <option value="16px">16</option>
            <option value="18px">18</option>
            <option value="20px">20</option>
            <option value="24px">24</option>
            <option value="30px">30</option>
            <option value="36px">36</option>
          </select>
        </span>
        <span class="ql-formats">
          <button
            type="button"
            class="ql-bold"
            aria-pressed="false"
            aria-label="bold"
          >
            <svg viewBox="0 0 18 18">
              <path
                class="ql-stroke"
                d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"
              ></path>
              <path
                class="ql-stroke"
                d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"
              ></path>
            </svg>
          </button>
          <button
            type="button"
            class="ql-italic"
            aria-pressed="false"
            aria-label="italic"
          >
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"></line>
              <line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"></line>
              <line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"></line>
            </svg>
          </button>
          <button
            type="button"
            class="ql-underline"
            aria-pressed="false"
            aria-label="underline"
          >
            <svg viewBox="0 0 18 18">
              <path
                class="ql-stroke"
                d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"
              ></path>
              <rect
                class="ql-fill"
                height="1"
                rx="0.5"
                ry="0.5"
                width="12"
                x="3"
                y="15"
              ></rect>
            </svg>
          </button>
          <button
            type="button"
            class="ql-strike"
            aria-pressed="false"
            aria-label="strike"
          >
            <svg viewBox="0 0 18 18">
              <line
                class="ql-stroke ql-thin"
                x1="15.5"
                x2="2.5"
                y1="8.5"
                y2="9.5"
              ></line>
              <path
                class="ql-fill"
                d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"
              ></path>
              <path
                class="ql-fill"
                d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"
              ></path>
            </svg>
          </button>
        </span>
        <span class="ql-formats"
          ><button
            type="button"
            class="ql-list"
            aria-pressed="false"
            value="ordered"
            aria-label="list: ordered"
          >
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>
              <line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>
              <line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>
              <line
                class="ql-stroke ql-thin"
                x1="2.5"
                x2="4.5"
                y1="5.5"
                y2="5.5"
              ></line>
              <path
                class="ql-fill"
                d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
              ></path>
              <path
                class="ql-stroke ql-thin"
                d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
              ></path>
              <path
                class="ql-stroke ql-thin"
                d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
              ></path>
            </svg></button
          ><button
            type="button"
            class="ql-list"
            aria-pressed="false"
            value="bullet"
            aria-label="list: bullet"
          >
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>
              <line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>
              <line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>
              <line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>
              <line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>
              <line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>
            </svg></button
        ></span>
        <span class="ql-formats">
          <button
            type="button"
            class="ql-indent"
            aria-pressed="false"
            value="-1"
            aria-label="indent: -1"
          >
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"></line>
              <line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"></line>
              <line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"></line>
              <polyline class="ql-stroke" points="5 7 5 11 3 9 5 7"></polyline>
            </svg>
          </button>
          <button
            type="button"
            class="ql-indent"
            aria-pressed="false"
            value="+1"
            aria-label="indent: +1"
          >
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"></line>
              <line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"></line>
              <line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"></line>
              <polyline
                class="ql-fill ql-stroke"
                points="3 7 3 11 5 9 3 7"
              ></polyline>
            </svg>
          </button>
        </span>
        <span class="ql-formats">
          <select class="ql-align" [title]="'Aligment'">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>

          <select class="ql-color" [title]="'Color'"></select>

          <select class="ql-background" [title]="'BackgroundColor'"></select>
        </span>
        <span class="ql-formats">
          <button
            type="button"
            class="ql-undo"
            aria-pressed="false"
            aria-label="undo"
            (click)="undo()"
          >
            <svg viewbox="0 0 18 18">
              <polygon
                class="ql-fill ql-stroke"
                points="6 10 4 12 2 10 6 10"
              ></polygon>
              <path
                class="ql-stroke"
                d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
              ></path>
            </svg>
          </button>
          <button
            type="button"
            class="ql-redo"
            aria-pressed="false"
            aria-label="redo"
            (click)="redo()"
          >
            <svg viewbox="0 0 18 18">
              <polygon
                class="ql-fill ql-stroke"
                points="12 10 14 12 16 10 12 10"
              ></polygon>
              <path
                class="ql-stroke"
                d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
              ></path>
            </svg>
          </button>
        </span>
        <span class="ql-formats">
          <button
            type="button"
            class="ql-link"
            aria-pressed="false"
            aria-label="link"
          >
            <svg viewBox="0 0 18 18">
              <line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"></line>
              <path
                class="ql-even ql-stroke"
                d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
              ></path>
              <path
                class="ql-even ql-stroke"
                d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
              ></path>
            </svg>
          </button>
          <button
            type="button"
            class="ql-image"
            aria-pressed="false"
            aria-label="image"
          >
            <svg viewBox="0 0 18 18">
              <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect>
              <circle class="ql-fill" cx="6" cy="7" r="1"></circle>
              <polyline
                class="ql-even ql-fill"
                points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
              ></polyline>
            </svg>
          </button>
        </span>
      </div>
    </quill-editor>
  </form>
  <div class="char-count-container" *ngIf="maxContentLength > 0">
    <span>{{ GetContentLength() }}/{{ maxContentLength }}</span>
  </div>
  <span
    [ngClass]="
      maxContentLength === 0
        ? 'error-without-char-count'
        : 'error-with-char-count'
    "
    class="error-with-char-count b2 b0"
    *ngIf="hasError()"
    >{{ GetError() }}</span
  >
</div>
